import { Box } from 'dash-ui';

import styled from 'styled-components';

export const GridBox = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 32%);
  gap: ${({ theme }) => theme.space * 4}px;
  @media ${({ theme }) => theme.devices.mobile} {
    grid-template-columns: repeat(1, 1fr);
    gap: ${({ theme }) => theme.space * 3}px;
  }
`;
